import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { setPref, signalsFromPath, signalsFromText } from '../lib/pref';

const UTM = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

// R5 — a UTM landing names a category / occasion via its path, utm_campaign or utm_content.
export function PrefSignals() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    const sp = new URLSearchParams(search);
    if (!UTM.some((k) => sp.get(k))) return;
    const pick = (o) => Object.fromEntries(Object.entries(o).filter(([, v]) => v));
    setPref({
      ...pick(signalsFromPath(pathname)),
      ...pick(signalsFromText(sp.get('utm_campaign'))),
      ...pick(signalsFromText(sp.get('utm_content'))),
    });
  }, [pathname, search]);
  return null;
}

export default PrefSignals;
